import * as React from 'react'
import ProviderTripsTable from '../../../containers/trips/ProviderTripsTable'
import TripFilterControls from '../../../containers/trips/TripFilterControls'
import {
  IDriverSearchObject,
  ISimpleDriverDTO,
  ITripFilters,
  IManualCompleteTripState,
  IMap,
  ITripSummaryItem,
  IProviderProductObject,
  IServiceObject,
  IScheduledRequestedTripsFiltersDTO,
  IUpdateOptimizedTripsDTO,
  ITripOptimizationResponse
} from '../../../types'
import Edit from '../../icons/ui/Edit'
import Cancel from '../../icons/ui/Cancel'
import Modal from 'react-modal'
import UIMessages from 'src/utils/ui-messages'
import Select from 'react-select'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import RouteOptimization from '../route-optimization/RouteOptimization'
import moment from 'moment'
import { ManualTripGroupRidesDTO } from 'src/types/trip-group-rides'
import PreloaderCircle from 'src/components/ui/PreloaderCircle'
import ModalWindow from 'src/components/ui/ModalWindow'
import { withNotification } from 'src/components/ui/notification-provider'
import ProgressBarModal from '../route-optimization/ProgressBarModal'
interface ITripsManagementProps extends RouteComponentProps<any> {
  orgId: string
  tripFilters: ITripFilters
  selectedRows: string[]
  operators: IDriverSearchObject[]
  getAllTrips: IMap<ITripSummaryItem>
  fetchOperators: (organizationId: string) => Promise<any>
  getTrip: (tripId: string) => Promise<any>
  assignMultipleOperator: (tripIds: string[], operator: ISimpleDriverDTO) => Promise<any>
  cancelMultipleOperator: (tripIds: string[], comment: string) => Promise<any>
  manualCompleteTripOperator: (tripIds: string[], comment: string, data: IManualCompleteTripState) => Promise<any>
  updateTripDriver: () => Promise<any>
  summaryFilters: ITripFilters
  isSelected: boolean
  products: IProviderProductObject[]
  services: IServiceObject[]
  optimizeRouteResponse: ITripOptimizationResponse | null | undefined
  optimizeTripResponse: ITripOptimizationResponse | null | undefined
  optimizeRoute: (request: IScheduledRequestedTripsFiltersDTO) => Promise<any>
  optimizeTrip: (request: IUpdateOptimizedTripsDTO) => Promise<any>
  groupScheduledTrips: (param: ITripFilters) => Promise<any>
  manual: (request: ManualTripGroupRidesDTO) => Promise<any>
  unGroupScheduledTrips: (param: ITripFilters) => Promise<any>
  getScheduledRequestedTrips: (params: IScheduledRequestedTripsFiltersDTO) => Promise<any>
  notification: {
    addNotification: (value: INotification) => void
  }
}

interface INotification {
  title: string
  message: string
  level: string
}

enum PaymentCompletionTypes {
  COMPLETE_WITH_PAYMENT = 0,
  COMPLETE_WITHOUT_PAYMENT = 1
}
const formOptions = [
  {
    label: 'Complete with payment',
    value: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
    apiData: {
      paymentRequired: true
    }
  },
  {
    label: 'Complete, no payment',
    value: PaymentCompletionTypes.COMPLETE_WITHOUT_PAYMENT,
    apiData: {
      paymentRequired: false
    }
  }
]
interface ITripsManagementState {
  isSelected: boolean
  manualGroupTripsModalIsOpen: boolean
  assignModalIsOpen: boolean
  manualCompleteModalIsOpen: boolean
  closeModalIsOpen: boolean
  isSubmitting: boolean
  disableNotification: boolean
  error: string
  reason: string
  otherReason: string
  tripIds: string[]
  selected: any
  completionType: PaymentCompletionTypes
  completionReason: string
  tripPrice: number
  enableAutoRefresh: boolean
  optimizeTripModalIsOpen: boolean
  groupBtnStyle: any
  isLoading: boolean
  successMessage: string
  userNotification: {
    ungroupPerServiceConfirmationModal: boolean
  }
  duration: number
  progressBarModalIsOpen: boolean
}

class TripsManagement extends React.Component<ITripsManagementProps, ITripsManagementState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSelected: false,
      manualGroupTripsModalIsOpen: false,
      assignModalIsOpen: false,
      closeModalIsOpen: false,
      manualCompleteModalIsOpen: false,
      isSubmitting: false,
      disableNotification: true,
      error: '',
      reason: '',
      otherReason: '',
      tripIds: [],
      selected: { label: '', value: '' },
      completionType: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
      completionReason: '',
      tripPrice: 0,
      enableAutoRefresh: true,
      optimizeTripModalIsOpen: false,
      groupBtnStyle: {
        opacity: 0.5
      },
      isLoading: false,
      successMessage: '',
      userNotification: {
        ungroupPerServiceConfirmationModal: false
      },
      duration: 0,
      progressBarModalIsOpen: false
    }
  }

  public async componentDidMount() {
    this.props.fetchOperators(this.props.orgId)
  }

  public componentDidUpdate(prevProps: ITripsManagementProps) {
    if (Object.keys(this.props.selectedRows).length === 1 && !this.state.isSelected) {
      this.setState({
        tripPrice: this.props.getAllTrips[Object.values(this.props.selectedRows)[0]].estimatedFare / 100,
        completionType: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
        completionReason: '',
        disableNotification: true,
        isSelected: true
      })

      return
    } else if (Object.keys(this.props.selectedRows).length === 0 && this.state.isSelected) {
      this.setState({
        tripPrice: 0,
        completionType: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
        completionReason: '',
        disableNotification: true,
        isSelected: false
      })

      return
    } else if (Object.keys(this.props.selectedRows).length > 1 && !this.state.isSelected) {
      this.setState({
        tripPrice: 0,
        completionType: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
        completionReason: '',
        disableNotification: true,
        isSelected: true
      })
    }
    const { services, timeFilter, timeStart } = this.props.summaryFilters

    if (
      JSON.stringify({ services, timeFilter, timeStart }) !==
      JSON.stringify({
        services: prevProps.summaryFilters.services,
        timeFilter: prevProps.summaryFilters.timeFilter,
        timeStart: prevProps.summaryFilters.timeStart
      })
    ) {
      this.canRequestGroupRide()
    }
  }

  public render() {
    const {
      isSelected,
      manualGroupTripsModalIsOpen,
      assignModalIsOpen,
      closeModalIsOpen,
      manualCompleteModalIsOpen,
      optimizeTripModalIsOpen,
      isLoading,
      successMessage,
      userNotification: { ungroupPerServiceConfirmationModal }
    } = this.state
    const saveText = this.state.isSubmitting ? 'Saving...' : 'Assign'
    const operatorOptions = this.props.operators.map(op => {
      return { label: op.name, value: op.id }
    })

    const toggleAutoRefresh = () => {
      this.setState({ enableAutoRefresh: !this.state.enableAutoRefresh })
    }

    let isManualGroupTrips
    if (isSelected && Object.keys(this.props.selectedRows).length >= 2) {
      isManualGroupTrips = true
    }

    const groupAndUngroupTooltip = () => (
      <span className='tooltiptext' style={{ backgroundColor: '#838383' }}>
        1. Please select one service first.
        <br />
        2. Please make sure the date filter selected is today and onwards only.
      </span>
    )

    return (
      <section className='fit-height'>
        <div className=' bg-white fit-height'>
          <div className='flex flex-end'>
            <span style={{ marginLeft: 'auto', marginRight: '50px' }}>
              <input type='checkbox' checked={this.state.enableAutoRefresh} onChange={toggleAutoRefresh} />
              {UIMessages.trip.enableAutoRefresh}
            </span>
          </div>
          <TripFilterControls type='provider' />
          <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '1%' }}>
            <div
              className={
                this.state.groupBtnStyle.opacity < 1
                  ? 'm1 cursor--pointer p1 bg-green-opaque rounded'
                  : 'm1 cursor--pointer p1 bg-green rounded'
              }
              onClick={this.toggleUngroupPerServiceModal}
            >
              <div className='g-tooltip'>
                <span className='Title font-white fs-14 px1'>Ungroup</span>
                {this.state.groupBtnStyle.opacity < 1 && groupAndUngroupTooltip()}
              </div>
            </div>
            <div
              className={
                this.state.groupBtnStyle.opacity < 1
                  ? 'm1 cursor--pointer p1 bg-green-opaque rounded'
                  : 'm1 cursor--pointer p1 bg-green rounded'
              }
              onClick={() => this.groupAndUngroupRequestedScheduledTrips('GROUP')}
            >
              <div className='g-tooltip'>
                <span className='Title font-white fs-14 px1'>Group</span>
                {this.state.groupBtnStyle.opacity < 1 && groupAndUngroupTooltip()}
              </div>
            </div>
            <div className='m1 cursor--pointer p1 bg-green rounded' onClick={this.handleOptimizeTripsModal}>
              <span className='Title font-white fs-14 px1'>{UIMessages.optimizeTrip.routeOptimizer}</span>
            </div>
          </div>
          {isSelected ? (
            <div className='tm-flex-row-reverse tm-pr-15'>
              <div className='m1 tm-w-auto cursor--pointer p1 bg-red rounded' onClick={this.handleCloseModal}>
                <Cancel className='icon--small svg-stroke-white' />
                <span className='Title font-white fs-14 ml1'>{UIMessages.manualTripCancel.menuItemLabel}</span>
              </div>
              <div
                className='m1 tm-w-auto cursor--pointer p1 bg-green rounded'
                onClick={this.handleManualCompleteModal}
              >
                <Edit className='icon--small svg-stroke-grey3' />
                <span className='Title font-white fs-14 ml1'>{UIMessages.manualTripComplete.menuItemLabel}</span>
              </div>
              <div className='m1 tm-w-auto cursor--pointer p1 bg-green rounded' onClick={this.handleAssignModal}>
                <Edit className='icon--small svg-stroke-grey3' />
                <span className='Title font-white fs-14 ml1'>{UIMessages.trip.assign}</span>
              </div>
              {isManualGroupTrips && (
                <div className='m1 g-w-auto cursor--pointer p1 bg-green rounded' onClick={this.handleManualGroupTrips}>
                  <Edit className='icon--small svg-stroke-grey3' />
                  <span className='Title font-white fs-14 ml1 tm-pb-3'>
                    {UIMessages.manualGroupTrips.manuallyGroupTrips}
                  </span>
                </div>
              )}
            </div>
          ) : (
            ''
          )}
          <ProviderTripsTable enableAutoRefresh={this.state.enableAutoRefresh} />
        </div>
        <div>
          <Modal isOpen={manualGroupTripsModalIsOpen} className='Modal' ariaHideApp={false}>
            <div className='overlay bg-dark-grey' />
            <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
              <div className='bg-white col-4 p2 relative'>
                <div className='flex justify-between items-center'>
                  <span className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase'>
                    {UIMessages.manualGroupTrips.groupTrips}
                  </span>
                  <button
                    className='absolute top-0 right-0'
                    onClick={this.handleCloseManualTripsModal}
                    style={{ zIndex: 10 }}
                  >
                    X
                  </button>
                </div>
                <div className='mb2' />
                <div className='ml2 mr2 mt1'>
                  <div style={{ textAlign: 'center', display: isLoading ? 'block' : 'none' }}>
                    <PreloaderCircle loading={true} />
                  </div>
                  {!isLoading && (
                    <div>
                      {successMessage && (
                        <div className='success-message'>
                          {successMessage.split('\n').map((line, index) => (
                            <p key={index}>{line}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal>
          <Modal isOpen={assignModalIsOpen} className='Modal' ariaHideApp={false}>
            <div className='overlay bg-dark-grey' />
            <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
              <div className='bg-white col-3 p2'>
                <span className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase'>
                  {UIMessages.trip.assign}
                </span>
                <div
                  style={{
                    pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                    opacity: this.state.isSubmitting ? 0.4 : 1.0
                  }}
                  className='ml2 mr2 mt1'
                >
                  <div className='mb1 mt1'>
                    <span className='font-grey3 h5'>Operators</span>
                    <Select
                      name='SelectOperator'
                      clearable={false}
                      value={this.state.selected}
                      onChange={this.onChange}
                      options={operatorOptions}
                    />
                  </div>
                  <div>{this.state.error && <p className='font-red m0'>{this.state.error}</p>}</div>
                </div>
                <div className='flex items-center justify-end mt3'>
                  <button
                    type='button'
                    onClick={this.handleAssignModal}
                    // disabled={this.state.isSubmitting}
                    className='CancelButton btn bg-white rounded font-light-grey mr2'
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    type='button'
                    onClick={this.onAssignDriver}
                    // disabled={this.state.isSubmitting}
                    className='SubmitButton btn bg-green rounded font-white weight-300'
                  >
                    {saveText}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal isOpen={closeModalIsOpen} className='Modal' ariaHideApp={false}>
            <div className='overlay bg-dark-grey' />
            <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
              <div className='bg-white col-4 p2'>
                <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
                  {UIMessages.manualTripCancel.modalTitle}
                </span>
                <div className='mt1'>
                  <span>{UIMessages.manualTripCancel.reasonQuestion}</span>
                  <div className='mt1' onChange={this.handleSelect}>
                    {UIMessages.manualTripCancel.cancelReasons.map((reason, i) => (
                      <div key={i}>
                        <label>
                          <input
                            type='radio'
                            name='reason'
                            value={reason}
                            defaultChecked={this.state.reason === reason}
                          />
                          <span>{reason}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className='mb1' onChange={this.handleOtherReasonUpdate}>
                    <textarea
                      className='col-12 p1 fit'
                      disabled={this.state.reason !== 'Other'}
                      value={this.state.otherReason}
                    />
                  </div>
                </div>
                <div className='mt1'>
                  <button
                    type='button'
                    onClick={this.handleCloseModal}
                    className='CancelButton btn bg-white rounded font-light-grey mr2'
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    type='submit'
                    className='SubmitButton btn bg-green rounded weight-300'
                    onClick={this.cancelTrip}
                    disabled={
                      this.state.reason === '' || (this.state.reason === 'Other' && this.state.otherReason === '')
                    }
                  >
                    <span className='font-white flex items-center'>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal isOpen={manualCompleteModalIsOpen} className='Modal' ariaHideApp={false}>
            <div className='overlay bg-dark-grey' />
            <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
              <div className='bg-white col-4 p2'>
                <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
                  {UIMessages.manualTripComplete.modalTitle}
                </span>
                <div>
                  <label>{UIMessages.manualTripComplete.completionTypeLabel}</label>
                  {formOptions.map(({ label, value }) => (
                    <div className='mb1' key={`completion-type-options-${value}`}>
                      <label>
                        <input
                          type='radio'
                          value={value}
                          checked={this.state.completionType === value}
                          onChange={this.onPaymentDetailsChange}
                        />
                        {label}
                      </label>
                    </div>
                  ))}
                </div>
                {Object.values(this.props.selectedRows).length === 1 && (
                  <div className='mt2'>
                    <label htmlFor='tripCost'>{UIMessages.manualTripComplete.tripPriceLabel}: </label>
                    <label>{this.state.tripPrice}</label>
                  </div>
                )}
                <div className='mt2'>
                  <label htmlFor='completionReason'>{UIMessages.manualTripComplete.completionReasonLabel}</label>
                  <textarea
                    id='completionReason'
                    className='col-12 p1 fit'
                    placeholder='Add reason'
                    // disabled={this.props.loading}
                    onChange={this.onMessageChange}
                    value={this.state.completionReason}
                  />
                </div>
                <div className='mt1'>
                  <button
                    type='button'
                    onClick={this.handleManualCompleteModal}
                    className='CancelButton btn bg-white rounded font-light-grey mr2'
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    type='submit'
                    onClick={this.onSubmitManualCompleteTrip}
                    className='SubmitButton btn bg-green rounded font-white weight-300'
                  >
                    <span className='flex items-center'>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          {optimizeTripModalIsOpen && (
            <RouteOptimization
              onClose={this.handleOptimizeTripsModal}
              optimizeTripModalIsOpen={optimizeTripModalIsOpen}
              orgId={this.props.orgId}
              products={this.props.products}
              services={this.props.services}
              optimizeRouteResponse={this.props.optimizeRouteResponse}
              optimizeTripResponse={this.props.optimizeTripResponse}
              optimizeRoute={this.props.optimizeRoute}
              optimizeTrip={this.props.optimizeTrip}
              getScheduledRequestedTrips={this.props.getScheduledRequestedTrips}
            />
          )}
          {/*  UNGROUP TRIPS PER SERVICENOTIFICATION MODAL */}
          <ModalWindow
            isOpen={ungroupPerServiceConfirmationModal}
            message={UIMessages.trip.ungroupTrips.ungroupTripsPerServiceMessage}
            okLabel={UIMessages.trip.ungroupTrips.confirm}
            title={UIMessages.trip.ungroupTrips.title}
            onCancel={this.toggleUngroupPerServiceModal}
            onConfirm={() => {
              this.groupAndUngroupRequestedScheduledTrips('UNGROUP')
              this.toggleUngroupPerServiceModal()
            }}
          />
          <ProgressBarModal
            isOpen={this.state.progressBarModalIsOpen}
            duration={this.state.duration}
            title={'Updating Trips...'}
          />
        </div>
      </section>
    )
  }

  private handleManualGroupTrips = async () => {
    const { selectedRows } = this.props
    this.setState({ isLoading: true, manualGroupTripsModalIsOpen: true })

    const tripIds: ManualTripGroupRidesDTO = {
      tripIds: Object.values(selectedRows).map(value => String(value))
    }

    const response = await this.props.manual(tripIds)

    if (response && response.success === false) {
      this.setState({ isLoading: false, manualGroupTripsModalIsOpen: false })
    } else {
      const groupRideId = response.groupRide ? response.groupRide.id : 'N/A'

      if (this.state.manualGroupTripsModalIsOpen) {
        this.setState({
          isLoading: false,
          successMessage: `Successfully grouped: ${
            Object.values(selectedRows).length
          } trips \nGroup Ride ID: ${groupRideId} \nProduct: ${response.product}`
        })
      }
    }
  }

  private handleCloseManualTripsModal = () => {
    this.setState({ manualGroupTripsModalIsOpen: false, successMessage: '' })
  }

  private handleAssignModal = () => {
    this.setState({
      assignModalIsOpen: !this.state.assignModalIsOpen,
      selected: { label: '', value: '' },
      error: ''
    })
  }
  private handleCloseModal = () => {
    this.setState({ closeModalIsOpen: !this.state.closeModalIsOpen })
  }
  private handleManualCompleteModal = () => {
    this.setState({ manualCompleteModalIsOpen: !this.state.manualCompleteModalIsOpen })
  }

  private handleOptimizeTripsModal = () => {
    this.setState(prevState => {
      return {
        optimizeTripModalIsOpen: !prevState.optimizeTripModalIsOpen
      }
    })
  }

  private toggleUngroupPerServiceModal = () => {
    const {
      userNotification,
      userNotification: { ungroupPerServiceConfirmationModal }
    } = this.state

    if (this.state && this.state.groupBtnStyle.opacity === 1) {
      this.setState({
        userNotification: {
          ...userNotification,
          ungroupPerServiceConfirmationModal: !ungroupPerServiceConfirmationModal
        }
      })
    }
  }

  private onChange = (option: any) => {
    this.setState({
      error: '',
      selected: option
    })
  }
  private handleSelect = (event: any) => {
    this.setState({
      reason: event.target.value
    })
  }
  private handleOtherReasonUpdate = (event: any) => {
    this.setState({
      otherReason: event.target.value
    })
  }
  private onPaymentDetailsChange = (e: any) => {
    this.setState({
      completionType: parseInt(e.target.value, 10)
    })
  }
  private notificationPrefToggle = () => {
    this.setState({
      disableNotification: !this.state.disableNotification
    })
  }
  private onMessageChange = (e: any) => {
    this.setState({
      completionReason: e.target.value
    })
  }
  private onCostChange = (e: any) => {
    this.setState({ tripPrice: parseFloat(e.target.value) })
  }
  private onAssignDriver = async () => {
    if (!this.state.selected) {
      return
    }

    this.setState({ isSubmitting: true })
    const operator = this.props.operators.find(op => op.id === this.state.selected.value)
    if (!operator) {
      return
    }

    const operatorPayload = {
      id: operator.id,
      operatorId: operator.id,
      firstName: operator.firstName,
      lastName: operator.lastName,
      phone: operator.phone
    }

    const tripIds = Object.values(this.props.selectedRows)

    if (tripIds.length > 20) {
      this.setState({
        isSubmitting: false,
        error: 'Trips selected exceed maximum limit of 20'
      })
    } else {
      const result = await this.props.assignMultipleOperator(Object.values(this.props.selectedRows), operatorPayload)

      if (result && result.status && result.status >= 400) {
        this.setState({
          isSubmitting: false,
          error: result.data
        })
      } else {
        this.props.updateTripDriver()
        this.setState({ isSubmitting: false })
        this.handleAssignModal()
      }
    }
  }
  private cancelTrip = () => {
    const comment = this.state.reason === 'Other' ? this.state.otherReason : this.state.reason

    const tripIds = Object.values(this.props.selectedRows)

    if (tripIds.length > 20) {
      this.setState({
        isSubmitting: false,
        error: 'Trips selected exceed maximum limit of 20'
      })

      this.props.notification.addNotification({
        title: 'Error',
        message: 'Trips selected exceed maximum limit of 20',
        level: 'error'
      })
    } else {
      const roundedToNearestFive = Math.ceil(tripIds.length / 5) * 5
      const duration = (roundedToNearestFive / 5) * 1750

      this.setState({
        duration
      })

      setTimeout(() => {
        this.setState({
          progressBarModalIsOpen: true
        })
      }, 250)

      this.props.cancelMultipleOperator(Object.values(this.props.selectedRows), comment).then(data => {
        if (data.totalFailed > 0) {
          this.props.notification.addNotification({
            title: 'Error',
            message: 'An error has occurred when cancelling some of the trips selected.',
            level: 'error'
          })
          this.setState({
            progressBarModalIsOpen: false
          })
        } else {
          setTimeout(() => {
            this.setState({
              progressBarModalIsOpen: false
            })
            this.props.notification.addNotification({
              title: 'Success',
              message: 'Trips cancelled successfully.',
              level: 'success'
            })
          }, this.state.duration + 500)
        }

        this.handleCloseModal()
        this.props.updateTripDriver()
      })
    }
  }
  private onSubmitManualCompleteTrip = async () => {
    const newPrice: number = Math.round(this.state.tripPrice * 100)

    const tripIds = Object.values(this.props.selectedRows)

    if (tripIds.length > 20) {
      this.setState({
        isSubmitting: false,
        error: 'Trips selected exceed maximum limit of 20'
      })

      this.props.notification.addNotification({
        title: 'Error',
        message: 'Trips selected exceed maximum limit of 20',
        level: 'error'
      })
    } else {
      const roundedToNearestFive = Math.ceil(tripIds.length / 5) * 5
      const duration = (roundedToNearestFive / 5) * 1750

      this.setState({
        duration
      })

      setTimeout(() => {
        this.setState({
          progressBarModalIsOpen: true
        })
      }, 250)

      const result = await this.props.manualCompleteTripOperator(
        Object.values(this.props.selectedRows),
        this.state.completionReason,
        {
          completionType: formOptions[this.state.completionType].label,
          price: this.state.tripPrice ? newPrice : 0,
          isNotificationOn: !this.state.disableNotification,
          paymentRequired: formOptions[this.state.completionType].apiData.paymentRequired
        }
      )

      if (result && result.status && result.status >= 400) {
        this.setState({
          isSubmitting: false,
          error: result.data
        })

        this.props.notification.addNotification({
          title: 'Error',
          message: 'An error has occurred when manually completing the trips selected.',
          level: 'error'
        })
      } else {
        setTimeout(() => {
          this.setState({
            progressBarModalIsOpen: false
          })
          this.props.notification.addNotification({
            title: 'Success',
            message: 'Trips updated successfully.',
            level: 'success'
          })
        }, this.state.duration + 500)
        this.props.updateTripDriver()
        this.setState({ isSubmitting: false })
      }
      this.handleManualCompleteModal()
    }
  }

  private canRequestGroupRide = () => {
    const { orgId, services, timeFilter } = this.props.summaryFilters
    let opacity = 0.5

    if (orgId && timeFilter && timeFilter.toLowerCase() === 'today' && services && services.length === 1) {
      if (this.validStartDate()) {
        opacity = 1
      }
    }
    this.setState(state => {
      const newState = { ...state }
      newState.groupBtnStyle.opacity = opacity
      return newState
    })
  }

  private validStartDate = () => {
    const { timeStart, timeEnd } = this.props.summaryFilters
    return (
      moment(timeStart).isSameOrAfter(moment(new Date()).startOf('day')) &&
      moment(timeStart).isSameOrBefore(moment(timeEnd))
    )
  }

  private groupAndUngroupRequestedScheduledTrips = (type: string) => {
    if (this.state && this.state.groupBtnStyle.opacity === 1) {
      const filters = this.props.summaryFilters
      const { orgId, services, timeStart, timeEnd } = filters

      const groupParams = {
        orgId,
        serviceId: services![0],
        timeStart,
        timeEnd
      }

      const unGroupParams = {
        serviceIds: services,
        startDate: moment(timeStart).format('YYYY-MM-DD'),
        endDate: moment(timeEnd).format('YYYY-MM-DD')
      }

      if (type === 'GROUP') {
        this.props.groupScheduledTrips(groupParams)
        return
      }
      if (unGroupParams.startDate !== undefined && unGroupParams.endDate !== undefined) {
        this.props.unGroupScheduledTrips(unGroupParams)
      }
    }
  }
}

export default withNotification(withRouter(TripsManagement))



// WEBPACK FOOTER //
// ./src/components/trips/management/ProviderTripsManagement.tsx